import Entity from '../entity'

export default class Gender extends Entity<number>{
    type_id: number;
    name: string;
}


